import * as React from 'react';
import { observer } from 'mobx-react';
import { ITranslationsCollection, translate } from '@estee/elc-service';
import { ISignInButton } from '../../interfaces/IProductCTA';
import { StyledSignInButton } from './ProductCTAStyles';
import { classes } from '../../utils/Classes';

export const SignInButton = translate(['guestUsersLoyaltyEarlyAccessCTALabel'])(
    observer(function SignInButton(props: ISignInButton) {
        const ShopNowButtonClassNames = classes('sign-in-button elc-add-to-bag-button');
        const { onSignInClick, translations } = props;
        const { guestUsersLoyaltyEarlyAccessCTALabel } = translations as ITranslationsCollection;

        return (
            <StyledSignInButton className={ShopNowButtonClassNames} onClick={onSignInClick}>
                {guestUsersLoyaltyEarlyAccessCTALabel}
            </StyledSignInButton>
        );
    })
);
